import {smartcaptureDriver} from "../utils/lanes-form-utils.js";

export const useLanesFormDefault = (setValue) => {
  const handleType = (selected) => {
    const value = selected?.value ?? "";
    if (value !== "INTERNAL_SMARTCAPTURE") {
      setValue("lane.smartcapturePin", null, { shouldDirty: true });
    }
    if(value === "INTERNAL_SMARTCAPTURE"){
      setValue("lane.rumination", true, { shouldDirty: true});
      setValue("lane.classification", true, { shouldDirty: true});
      setValue("lane.ocr", "SUPPLEMENT", { shouldDirty: true});
      setValue("lane.images", "ALL", { shouldDirty: true});
    }
    if(value === "API"){
      setValue("lane.ocr", "SUPPLEMENT", { shouldDirty: true});
      setValue("lane.classification", true, { shouldDirty: true});
      setValue("lane.rumination", true, { shouldDirty: true});
      setValue("lane.images", null, { shouldDirty: true});
    }
    if(value === "SENTRY_CLOUD"){
      setValue("lane.ocr", "DISABLED", { shouldDirty: true});
      setValue("lane.images", null, { shouldDirty: true});
      setValue("lane.rumination", false, { shouldDirty: true});
      setValue("lane.classification", false, { shouldDirty: true});
    }
    if(value === "MOBILE_APP" || value === "MOBILE_CAMERA"){
      setValue("lane.rumination", false, { shouldDirty: true});
      setValue("lane.classification", false, { shouldDirty: true});
      setValue("lane.adr", false, { shouldDirty: true});
      setValue("lane.showlane", false, { shouldDirty: true});
    }
    setValue("smartcaptureDriver", smartcaptureDriver, { shouldDirty: true});
    return value;
  };

  return { handleType };
}